import * as i0 from '@angular/core';
import * as i1 from './table.module';
import * as i2 from '@angular/common';
import * as i3 from '../icon/icon.component';
import * as i4 from './table.component';
import * as i5 from './table-row.directive';
import * as i6 from '../icon/icon.module';
export const BllTableModuleNgFactory:i0.NgModuleFactory<i1.BllTableModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.BllIconComponent = (<any>(null as any));
var _decl0_12:i4.BllTableComponent = (<any>(null as any));
var _decl0_13:i5.BllTableColumnDirective = (<any>(null as any));
var _decl0_14:i2.AsyncPipe = (<any>(null as any));
var _decl0_15:i2.UpperCasePipe = (<any>(null as any));
var _decl0_16:i2.LowerCasePipe = (<any>(null as any));
var _decl0_17:i2.JsonPipe = (<any>(null as any));
var _decl0_18:i2.SlicePipe = (<any>(null as any));
var _decl0_19:i2.DecimalPipe = (<any>(null as any));
var _decl0_20:i2.PercentPipe = (<any>(null as any));
var _decl0_21:i2.TitleCasePipe = (<any>(null as any));
var _decl0_22:i2.CurrencyPipe = (<any>(null as any));
var _decl0_23:i2.DatePipe = (<any>(null as any));
var _decl0_24:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_25:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_26:i2.KeyValuePipe = (<any>(null as any));
var _decl0_27:i2.CommonModule = (<any>(null as any));
var _decl0_28:i6.BllIconModule = (<any>(null as any));
var _decl0_29:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_30:i0.ElementRef<any> = (<any>(null as any));
function _View_BllTableComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_BllTableComponent_1_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.header;
  currVal_0;
  const currVal_1:any = (_any.sorted !== null);
  currVal_1;
  const currVal_2:any = ((_any.sorted === 'asc')? 'dropdown-up': 'dropdown');
  currVal_2;
  const currVal_3:any = 'bll-table-filter-icon';
  currVal_3;
  const currVal_4:any = _decl0_11.currentClassNames;
  currVal_4;
  const pd_5:any = ((<any>_decl0_12.sort(_any,_any)) !== false);
}
function _View_BllTableComponent_1_3():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.header;
  currVal_0;
}
function _View_BllTableComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.styles;
  currVal_0;
  const currVal_1:any = _any.sortable;
  currVal_1;
  const currVal_2:any = _any;
  currVal_2;
  const currVal_3:any = ((_any.sorted === 'asc')? 'ascending': ((_any.sorted === 'desc')? 'descending': 'null'));
  currVal_3;
  const currVal_4:any = true;
  currVal_4;
}
function _View_BllTableComponent_1_7():void {
  var _any:any = (null as any);
}
function _View_BllTableComponent_1_6():void {
  var _any:any = (null as any);
}
function _View_BllTableComponent_1_5():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'bll-table-column ',_any.class,'');
  currVal_0;
  const currVal_1:any = _any.ngClass;
  currVal_1;
  const currVal_2:any = _any.styles;
  currVal_2;
  const currVal_3:any = _any.header;
  currVal_3;
  const currVal_4:any = _any;
  currVal_4;
  const currVal_5:any = {$implicit:(_any[_any] || _any),data:(_any[_any] || _any),
      index:_any};
  currVal_5;
  const currVal_6:any = _any.template;
  currVal_6;
}
function _View_BllTableComponent_1_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_12.columns;
  currVal_0;
}
function _View_BllTableComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_12.columns;
  currVal_0;
  const currVal_1:any = _decl0_12.displayData;
  currVal_1;
}
